import React, { forwardRef, useState } from 'react';
import { Popover, Text } from '@wix/design-system';
import { ArrowRight } from '@wix/wix-ui-icons-common/odeditor';
import s from './BusinessNameTile.scss';
export const POPOVER_OPEN_DELAY_MS = 250;
export const BusinessNameTile = /*#__PURE__*/forwardRef((_ref, ref) => {
  let name = _ref.name,
    isSelected = _ref.isSelected,
    onSelect = _ref.onSelect,
    onHoverChange = _ref.onHoverChange,
    tooltipContent = _ref.tooltipContent,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    _ref$nameWeight = _ref.nameWeight,
    nameWeight = _ref$nameWeight === void 0 ? 'bold' : _ref$nameWeight,
    _ref$showArrowWhenSel = _ref.showArrowWhenSelected,
    showArrowWhenSelected = _ref$showArrowWhenSel === void 0 ? false : _ref$showArrowWhenSel;
  const _useState = useState(false),
    showPopover = _useState[0],
    setShowPopover = _useState[1];
  const className = `${s.tile} ${isSelected ? s.selected : ''} ${size === 'large' ? s.large : ''} ${showArrowWhenSelected ? s.showArrowWhenSelected : ''}`.trim();
  const tile = /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: className,
    role: "button",
    tabIndex: 0,
    "aria-pressed": isSelected,
    "data-hook": "business-name-tile",
    onClick: () => onSelect(name),
    onKeyDown: e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (!e.repeat) {
          onSelect(name);
        }
      }
    },
    onMouseEnter: tooltipContent ? () => setShowPopover(true) : undefined,
    onMouseLeave: tooltipContent ? () => setShowPopover(false) : undefined
  }, /*#__PURE__*/React.createElement("div", {
    className: s.nameWrapper
  }, /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    weight: nameWeight,
    className: s.nameText
  }, name.name), /*#__PURE__*/React.createElement(ArrowRight, {
    "aria-hidden": true,
    className: s.arrow
  })));
  if (!tooltipContent) {
    return tile;
  }
  return /*#__PURE__*/React.createElement(Popover, {
    shown: showPopover,
    showDelay: POPOVER_OPEN_DELAY_MS,
    placement: "top",
    skin: "light",
    appendTo: "window",
    showArrow: true,
    maxWidth: "320px",
    animate: true,
    onShow: () => onHoverChange == null ? void 0 : onHoverChange(true),
    onHide: () => onHoverChange == null ? void 0 : onHoverChange(false)
  }, /*#__PURE__*/React.createElement(Popover.Element, null, tile), /*#__PURE__*/React.createElement(Popover.Content, null, tooltipContent));
});
BusinessNameTile.displayName = 'BusinessNameTile';
//# sourceMappingURL=BusinessNameTile.js.map